import React from "react";
import {Button, Grid, Paper, Typography, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

const RentableAgain = () => {
    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);
    const navigate = useNavigate();

    // make the vehicle rentable again
    const handleRentable = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        // todo integrate WRest
        navigate(`/network/ra-search`);
    }

    //make the vehicle unrentable again
    const handleUnRentable = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        // todo integrate WRest
        navigate(`/network/ra-search`);
    }

    return (<Paper elevation={1} sx={{p: theme.spacing(2), mb: theme.spacing(2)}}>
                <Grid container columnSpacing={2}>
                    <Grid item xs={12} sx={{display: "flex", justifyContent: "center", mb: theme.spacing(2)}}>
                        <Typography variant={"h6"} >
                            {t("raCheckOutIn.rentableAgain.header.title")}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{display: "flex", justifyContent: "center", mb: theme.spacing(2)}}>
                        <img src={"/images/network/VehicleRentableAgain.png"} className={"img-max-width-500"}/>
                    </Grid>
                    <Grid item xs={12} sx={{display: "flex", justifyContent: "center", mb: theme.spacing(2)}}>
                        <Typography variant={"bodyLarge"} >
                            {t("raCheckOutIn.rentableAgain.header.subtitle")}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{display: "flex", justifyContent: "center"}}>
                        <Button  sx={{mx: theme.spacing(1), color: theme.palette.neutral.main}}
                                 color={"primary"}
                                 onClick={(e: React.SyntheticEvent) => handleRentable(e)}>
                            {t("raCheckOutIn.rentableAgain.button.yes")}
                        </Button>

                        <Button variant={"outlined"} color={"primary"}
                                sx={{mx: theme.spacing(1)}} onClick={(e: React.SyntheticEvent) => handleUnRentable(e)}>
                            {t("raCheckOutIn.rentableAgain.button.no")}
                        </Button>
                    </Grid>
                </Grid>
        </Paper>)
}

export default RentableAgain;